export default __webpack_public_path__ + "static/present-96387184c3aa8ebf9e7906889146fe92.mp4";